require('./bootstrap');
require('./jquery-ui.min');
require('../../shared/greedynav/greedynav');
require('../../shared/bootstrap-4.0.0-beta.2/dist/js/bootstrap.min');
require('./header');
require('./sly.min');
require('./plugins');
require('./jquery.cookie');
require('../../shared/fullcalendar-2.1.1/fullcalendar');
require('../../shared/fullcalendar-2.1.1/lang-all');
require('cropit.jquery3');
window.JSZip = require('jszip/dist/jszip.min');
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.addVirtualFileSystem(pdfFonts);
require('bootstrap-autocomplete/dist/latest/bootstrap-autocomplete.min');
require('datatables.net-buttons/js/dataTables.buttons.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('../../shared/media-boxes/components/Fancybox/jquery.fancybox.min');
require('../../shared/media-boxes/components/Isotope/jquery.isotope.min');
require('../../shared/media-boxes/components/imagesLoaded/jquery.imagesLoaded.min');
require('../../shared/media-boxes/components/Transit/jquery.transit.min');
require('../../shared/media-boxes/components/jQuery Easing/jquery.easing');
require('../../shared/media-boxes/components/Waypoints/waypoints.min');
require('../../shared/media-boxes/components/Modernizr/modernizr.custom.min');
require('../../shared/media-boxes/components/Magnific Popup/jquery.magnific-popup.min');
require('../../shared/media-boxes/js/jquery.mediaBoxes.dropdown');
require('../../shared/media-boxes/js/jquery.mediaBoxes');
require('../../shared/js/app.js');

window.Moment = require('moment');

import {MediaBoxes} from "./components/MediaBoxes";
import {GoogleTagManager} from "./libraries/GoogleTagManager";
import {OrderImagesDownloader} from "./components/OrderImagesDownloader";

if (useGtmEcommerceEvents) {
    let googleTagManager = new GoogleTagManager();
    googleTagManager.init();
}

addEventListener('DOMContentLoaded', e => {
    const mediaBoxes = new MediaBoxes();

    mediaBoxes.init();

    $('table').on('init.dt', function () {
        $('.order-image-download-btn').each(function () {
            $(this).click(function (e) {
                e.preventDefault();

                let orderImagesDownloader = new OrderImagesDownloader();
                orderImagesDownloader.download(this);
            });
        });

        $('.dt-length .dt-input').addClass('custom-select');
        $('.dt-search .dt-input').addClass('form-control form-control-sm');
    });
});
